module.exports = __webpack_public_path__ + "img/mf.f49c0355.png";